import { NavigationCross, OperationsSearch } from '@energy-retailer/icons';

type PostcodeInputProps = {
  onChange: (val: string) => void;
  value: string;
};

export const PostcodeInput = ({ onChange, value }: PostcodeInputProps) => {
  return (
    <div className="align-center flex w-[6.875rem] border-b-2 border-pink pb-a md:w-[7.5rem] lg:w-[7.625rem]">
      <input
        placeholder="3000"
        id="postcode"
        name="postcode"
        type="text"
        value={value}
        onChange={(e) => {
          const regex = /(?!^\+)[^\d]+/g;
          e.target.value = e.target.value.trim().replace(regex, '');
          onChange(e.target.value);
        }}
        maxLength={4}
        className="text-h2 m-0 w-full border-none bg-transparent p-0 leading-none placeholder:text-gray-200 focus:shadow-none focus:outline-none focus:ring-0 disabled:pointer-events-none disabled:text-gray-200"
      />
      {value ? (
        <button
          onClick={() => onChange('')}
          type="button"
          aria-label="Clear postcode"
        >
          <NavigationCross className="h-icon-xs w-icon-xs shrink-0 text-pink" />
        </button>
      ) : (
        <OperationsSearch
          className="h-icon-xs w-icon-xs shrink-0 text-pink"
          data-testid="search-glass"
        />
      )}
    </div>
  );
};
